import { TContractType } from "./contractType";
import NegotiationMassive from "../api/negotiationMassive";
import moment from "moment";

const ContractTypeMapper = new Map<TContractType, string>([
    ['br-materials', 'BR_MATERIALS'],
    ['br-services', 'BR_SERVICES'],
    ['las-materials', 'LAS_MATERIALS'],
    ['las-services', 'LAS_SERVICES'],
    ['br-materials-simple', 'BR_MATERIALS_SIMPLE']
]);

export const downloadFile = (id: string, contractType: TContractType): void => {
    NegotiationMassive.exportContracts(contractType, Number(id)).then((response) => {
        const fileType = ContractTypeMapper.get(contractType); 
        const dateTime = moment().format('yyyyMMDDhhmmss'); 
        const nameFile = `${fileType}_${dateTime}`;

        const type = response.headers['content-type']
        const blob = new Blob([response.data], { type: type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = nameFile
        link.click()
    }).catch((err) => console.error(err))
};